<template>
  <b-modal
    v-model="dataInModal.show"
    :title="`change ${dataInModal.type}`"
    centered
    :ok-only="true"
    :ok-title="`change`"
    @ok="changePersonneleEvaluation"
  >
    <b-container fluid>
      <b-row class="w-100">
        <b-col
          v-if="dataInModal.type === 'evaluator'"
          cols="12"
        >
          <b-form-group
            label="select evaluator"
            label-for="select evaluator"
          >
            <b-form-select
              v-model="evaluatorId"
              :options="optionsUsers"
              text-field="label"
              value="value"
              placeholder="Evaluator"
              :clearable="false"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="dataInModal.type === 'activity'"
          cols="12"
        >
          <b-input
            v-model="activity"
            placeholder="Activity"
          />
        </b-col>
        <b-col
          v-if="dataInModal.type === 'product'"
          cols="12"
        >
          <span v-if="loadingProducts">loading...</span>
          <div v-else>
            <b-form-checkbox-group
              v-model="productId"
              :options="products"
              stacked
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import axios from 'axios'
// import VSelect from 'vue-select'

export default {
  // components: {
  //   'v-select': VSelect,
  // },
  props: {
    dataInModal: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      evaluatorId: null,
      activity: null,
      loadingProducts: false,
      productId: [],
    }
  },
  computed: {
    optionsUsers() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },
    products() {
      return this.$store.getters['generalData/productsInCertificate/getProductsById'](this.dataInModal.certificate_category_id)
    },
  },
  watch: {
    'dataInModal.certificate_category_id': {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          this.loadingProducts = true
          await this.$store.dispatch('generalData/productsInCertificate/fetchProducts', newVal)
          this.loadingProducts = false
        }
      },
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      await this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
  },
  methods: {
    changePersonneleEvaluation() {
      this.$swal({
        title: 'Loading ...',
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        onOpen: () => {
          this.$swal.showLoading()
        },
      })
      let payload = {}
      if (this.dataInModal.type === 'evaluator') {
        payload = {
          evaluator_id: this.evaluatorId,
        }
      } else if (this.dataInModal.type === 'activity') {
        payload = {
          activity: this.activity,
        }
      } else if (this.dataInModal.type === 'product') {
        payload = {
          product_category_ids: this.productId,
        }
      }

      axios.put(`/personnel-evaluation/${this.dataInModal.id}`, payload).then(res => {
        if (res.status === 200 || res.status === 201) {
          this.$swal.close()
          window.location.reload()
        }
      }).catch(error => {
        if (error.response.status) {
          this.$swal.close()
          window.location.reload()
        }
      }).finally(() => {
        this.$swal.close()
        window.location.reload()
      })
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
